import { render, staticRenderFns } from "./SettlementTypePanel.vue?vue&type=template&id=1bfd623e&scoped=true"
import script from "./SettlementTypePanel.vue?vue&type=script&lang=js"
export * from "./SettlementTypePanel.vue?vue&type=script&lang=js"
import style0 from "./SettlementTypePanel.vue?vue&type=style&index=0&id=1bfd623e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd623e",
  null
  
)

export default component.exports